import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
	return (
		<Card className="quote-card-view">
			<Card.Body>
				<blockquote className="blockquote mb-0">
					<p style={{ textAlign: "left" }}>
						Hi Everyone, I am <span className="purple">ChengGuang Li </span>
						from <span className="purple"> China.</span>
						<br />I am somebody who loves hard work and has high standards.
						<br />
						<br />
						In my past work, I have participated in the development and maintenance of several projects, including 
						<i>
							<b className="purple"> web applications</b>,
						</i>
						<i>
							<b className="purple"> mobile applications</b>,
						</i>
						<i>
							<b className="purple"> microservices</b> 
						</i>
						{" "}
						development, etc. I have a 
						<i>
							<b className="purple"> strong passion</b> 
						</i>
						{" "}
						for writing 
						<i>
							<b className="purple"> high-quality code</b>, 
						</i>
						{" "}
						 and 
						 <i>
							<b className="purple"> improving user experience</b> 
						</i>
						.						
						<br />
						<br />
                        My work style emphasizes attention to 
						{" "}
						<i>
						<b className="purple">detail</b> 
						</i>
						, 
						 {" "}
						 <i>
						<b className="purple">quality</b> 
						</i>
						 , and 
						 {" "}
						 <i>
						<b className="purple">teamwork</b> 
						{" "}
						</i>
						 I am able to 
						 {" "}
						 <i>
						    <b className="purple">quickly adapt</b> 
						</i>
						{" "}
						to new technologies and environments.
						<br />
						<br />
						I also value 
						{" "}
						<i>
						    <b className="purple">self-learning </b> 
						</i>
						{" "}
						and 
						<i>
						    <b className="purple"> continuous improvement</b> 
						</i>
						, often 
						<i>
						    <b className="purple"> attending technical training</b> 
						</i>
						{" "}
						 to 
						 <i>
						    <b className="purple"> keep up with the industry trends </b> 
						</i>
						  and enhance my
						  <i>
						    <b className="purple"> skill set  </b> 
						</i>
							 and
						  <i>
						    <b className="purple"> adaptability</b> 
						</i>	 
						.
						<br />
						<br />
						Apart from coding, some other activities that I love to do!
					</p>
					<ul>
						<li className="about-activity">
							<ImPointRight /> Tech Forum Surfing
						</li>
						<li className="about-activity">
							<ImPointRight /> Gardening
						</li>
						<li className="about-activity">
							<ImPointRight /> Travelling
						</li>
					</ul>

					<p style={{ marginBlockEnd: 0, color: "rgb(155 126 172)" }}>
						"Strive to build things that make a difference!"{" "}
					</p>
					<footer className="blockquote-footer">ChengGuang</footer>
				</blockquote>
			</Card.Body>
		</Card>
	);
}

export default AboutCard;
